import { put, call, take, fork } from 'redux-saga/effects'
import { questionListMakeActiveService } from '../../api/question'
import { questionListMakeActiveSuccess } from '../../reducers/question/action'
import { QUESTION_LIST_MAKE_ACTIVE } from '../../reducers/question/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* questionListMakeActiveFlow(payload) {
  try {
    const { ids, callback } = payload
    yield call(questionListMakeActiveService, ids)

    yield put(questionListMakeActiveSuccess(ids))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* questionListMakeActiveWatcher() {
  while (true) {
    const action = yield take(QUESTION_LIST_MAKE_ACTIVE)
    const { payload } = action

    yield fork(generalSaga, questionListMakeActiveFlow, payload)
  }
}
